const RECEIPTS_KEY = 'td_scan_unlock_receipts'

export interface UnlockReceipt {
  user_id: string
  scan_id: string
  payment_reference: string
  confirmed_at: string
}

/**
 * Keeps a local record of every confirmed single-report payment
 * (user ↔ scan ↔ payment reference). The server remains the source of truth
 * for unlocking; this lets support and the client re-link a scan to its payment.
 * Only call after the provider has confirmed the payment.
 */
export function recordUnlockReceipt(receipt: Omit<UnlockReceipt, 'confirmed_at'>) {
  try {
    const existing = readUnlockReceipts().filter(
      (r) => r.payment_reference !== receipt.payment_reference,
    )
    const next: UnlockReceipt[] = [
      ...existing,
      { ...receipt, confirmed_at: new Date().toISOString() },
    ].slice(-50)
    localStorage.setItem(RECEIPTS_KEY, JSON.stringify(next))
  } catch {
    // Storage unavailable — server-side record still holds.
  }
}

export function readUnlockReceipts(): UnlockReceipt[] {
  try {
    const raw = localStorage.getItem(RECEIPTS_KEY)
    const parsed: unknown = raw ? JSON.parse(raw) : []
    return Array.isArray(parsed) ? (parsed as UnlockReceipt[]) : []
  } catch {
    return []
  }
}
